import { Button, Color, Flex, Icon, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { BankReconciliationConnectShine } from '../../../../../../../../assets/images'
import { useSegment } from '../../../../../../../../hooks'
import { getImageClassName } from '../../../../../../../../utils/getClassName'
import * as BankAccountListStyled from '../../styles'
import * as Styled from './styles'

interface TransactionsDemoBannerProps {
  shouldShow?: boolean
  withBottomMargin?: boolean
  onOpenSandbox: () => void
}

export const TransactionsDemoBanner = ({
  shouldShow,
  withBottomMargin,
  onOpenSandbox,
}: TransactionsDemoBannerProps): ReactElement | null => {
  const { t } = useTranslation()
  const { track } = useSegment()

  const handleOpenSandboxClick = useCallback(() => {
    track('XXX - Reconciliation Transactions Demo Opened (Client)')
    onOpenSandbox()
  }, [onOpenSandbox, track])

  if (!shouldShow) {
    return null
  }

  return (
    <BankAccountListStyled.BannerWrapper>
      <Styled.DemoBannerContainer>
        <Styled.TextColumn>
          <Text variant="h2" weight="bold">
            {t('bank_transactions.demo_banner.title')}
          </Text>
          <Space size="s12" />
          <Styled.BulletList>
            <Styled.BulletItem>
              <Styled.IconBadge>
                <Icon icon="receiptText" color={Color.Green700} />
              </Styled.IconBadge>
              <Text variant="bodyMD">{t('bank_transactions.demo_banner.bullet_one')}</Text>
            </Styled.BulletItem>
            <Styled.BulletItem>
              <Styled.IconBadge>
                <Icon icon="banknote" color={Color.Green700} />
              </Styled.IconBadge>
              <Text variant="bodyMD">{t('bank_transactions.demo_banner.bullet_two')}</Text>
            </Styled.BulletItem>
            <Styled.BulletItem>
              <Styled.IconBadge>
                <Icon icon="repeat2" color={Color.Green700} />
              </Styled.IconBadge>
              <Text variant="bodyMD">{t('bank_transactions.demo_banner.bullet_three')}</Text>
            </Styled.BulletItem>
          </Styled.BulletList>
          <Space size="s12" />
          {/* Flex keeps the button at its content width instead of letting TextColumn's stretch alignment expand it */}
          <Flex>
            <Button size="sm" onClick={handleOpenSandboxClick} icon="mousePointerClick">
              {t('bank_transactions.demo_banner.cta')}
            </Button>
          </Flex>
        </Styled.TextColumn>
        <Styled.IllustrationContainer className={getImageClassName()}>
          <BankReconciliationConnectShine />
        </Styled.IllustrationContainer>
      </Styled.DemoBannerContainer>
      {withBottomMargin && <Space size="s24" />}
    </BankAccountListStyled.BannerWrapper>
  )
}
